// src/services/firebase/firebaseConfig.js
import { initializeApp } from 'firebase/app';
import { getFunctions } from 'firebase/functions';
import { getFirestore } from 'firebase/firestore';
import { getAuth, GoogleAuthProvider } from 'firebase/auth'; // 🆕 הוספת GoogleAuthProvider
import { getStorage } from 'firebase/storage';

// הגדרות Firebase מהפרויקט שלך
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
};

// בדיקה שכל המפתחות הנדרשים קיימים
const requiredKeys = [
  'REACT_APP_FIREBASE_API_KEY',
  'REACT_APP_FIREBASE_AUTH_DOMAIN', 
  'REACT_APP_FIREBASE_PROJECT_ID',
  'REACT_APP_FIREBASE_STORAGE_BUCKET'
];

const missingKeys = requiredKeys.filter(key => !process.env[key]);

if (missingKeys.length > 0) {
  console.error('❌ Missing Firebase configuration keys:', missingKeys);
  console.error('Please add them to your .env file');
} else {
  // console.log('✅ All Firebase configuration keys are present');
}

// אתחול Firebase
let app;
try {
  app = initializeApp(firebaseConfig);
} catch (error) {
  console.error('❌ Firebase initialization failed:', error);
  throw error;
}

// אתחול שירותים
export const db = getFirestore(app);
export const functions = getFunctions(app);
export const auth = getAuth(app);
export const storage = getStorage(app);

// 🆕 הגדרת Google Auth Provider
export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({
  prompt: 'select_account' // מאלץ את המשתמש לבחור חשבון גוגל
});

// בדיקת חיבור לשירותים
export const testFirebaseConnection = async () => {
  try {
    return {
      success: true,
      message: 'Firebase connection successful',
      services: {
        firestore: true,
        functions: true,
        storage: true,
        auth: true
      }
    };
  } catch (error) {
    console.error('❌ Firebase connection test failed:', error);
    return {
      success: false,
      error: error.message,
      services: {
        firestore: false,
        functions: false,
        storage: false,
        auth: false
      }
    };
  }
};

export default app;